// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-container {
  max-width: 1200px;
}

.homepage-container, .homepage-container > * {
  margin: 0 auto;
  width: 100%
}`, "",{"version":3,"sources":["webpack://./src/Components/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd;AACF","sourcesContent":[".homepage-container {\n  max-width: 1200px;\n}\n\n.homepage-container, .homepage-container > * {\n  margin: 0 auto;\n  width: 100%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
